import { gql } from '@apollo/client';

export const DELETE_AD = gql`
  mutation DeleteAd($id: ID!, $adType: AdTypeEnum = VACANCY) {
    deleteAd(input: { id: $id, adType: $adType }) {
      status
    }
  }
`;

export const SWITCH_ACTIVATION_AD = gql`
  mutation SwitchActivateAd($id: ID!, $adType: AdTypeEnum = VACANCY) {
    switchActivationAd(input: { id: $id, adType: $adType }) {
      ad {
        __typename
        ... on Vacancy {
          id
          activatable
        }
        ... on Resume {
          id
          activatable
        }
      }
      status
    }
  }
`;
